import { CompoundFilterOptions, CompoundFilterItems, CompoundFilterProvider } from './components';

export const CompoundFilter = {
  Options: CompoundFilterOptions,
  Items: CompoundFilterItems,
  Provider: CompoundFilterProvider,
};

export type { CompoundFilterOptionsProps } from './components';
